module.exports = __webpack_public_path__ + "static/media/2key_logo.9a0b4c7fdeb0645b7a6f70c75d77bf54.svg";